import { CloudOff, RefreshCw, Trash2, Wifi } from "lucide-react";
import { Button } from "@/components/ui/button";

/** Banner status jaringan + antrean scan yang belum terkirim */
export function OfflineBanner({ queue, testid = "offline-banner", accent = "emerald" }) {
  const { pending, online, sync, syncing, remove } = queue;
  if (online && !pending.length) return null;
  const tone = !online ? "border-rose-500/40 bg-rose-500/10" : accent === "amber" ? "border-amber-500/40 bg-amber-500/10" : "border-emerald-500/40 bg-emerald-500/10";
  return (
    <div className={`mt-3 rounded border p-3 text-xs ${tone}`} data-testid={testid}>
      <div className="flex flex-wrap items-center gap-2">
        {online ? <Wifi className="h-4 w-4 text-emerald-400" /> : <CloudOff className="h-4 w-4 text-rose-400" />}
        <span className="text-slate-200" data-testid={`${testid}-status`}>
          {online ? "Online" : "Offline — scan tetap disimpan di perangkat ini"}
          {pending.length ? <> · <b className="font-mono">{pending.length}</b> scan menunggu sinkron</> : null}
        </span>
        {pending.length > 0 && (
          <Button type="button" size="sm" variant="outline" className="ml-auto h-7 border-slate-700 text-xs" disabled={!online || syncing} onClick={sync} data-testid={`${testid}-sync`}>
            <RefreshCw className={`mr-1 h-3 w-3 ${syncing ? "animate-spin" : ""}`} /> Sinkron sekarang
          </Button>
        )}
      </div>
      {pending.length > 0 && (
        <ul className="mt-2 max-h-28 space-y-1 overflow-y-auto" data-testid={`${testid}-list`}>
          {pending.map((p) => (
            <li key={p.qid} className="flex items-center gap-2 font-mono text-[11px] text-slate-400">
              <span className="text-amber-300">{p.code}</span>
              <span>{p.result || (p.qty != null ? `${p.qty} pcs` : "")}</span>
              <span className="text-slate-600">{new Date(p.queuedAt).toLocaleTimeString("id-ID", { hour: "2-digit", minute: "2-digit" })}</span>
              <button type="button" onClick={() => remove(p.qid)} className="ml-auto text-slate-600 hover:text-rose-400" title="Hapus dari antrean" data-testid={`${testid}-remove-${p.code}`}><Trash2 className="h-3 w-3" /></button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
